module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-venue-3545248ecd2ce4a1476635e97fd066ec.png";